import React, { useState } from 'react'
import styled from 'styled-components'
import uniqid from 'uniqid'

const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  label {
    font-size: 14px;
    line-height: 18px;
    font-family: 'Open Sans';
    font-weight: 400;
    padding-left: 30px;
    display: block;
    color: ${props => props.hasError ? '#ff0000' : '#555555'};
    cursor: pointer;

    &:before {
      display: block;
      content: '';
      position: absolute;
      width: 18px;
      height: 18px;
      border: 2px solid ${props => props.hasError ? '#ff0000' : '#777777'};
      left: 0;
      top: 0;
      border-radius: 50%;
    }

    &:after {
      display: block;
      content: '';
      position: absolute;
      width: 8px;
      height: 8px;
      background-color: #00A6CE;
      left: 5px;
      top: 5px;
      opacity: 0;
      border-radius: 50%;
    }
  }

  input:checked ~ label::before {
    border: 2px solid #00A6CE;
  }

  input:checked ~ label::after {
    opacity: 1;
  }
`

const RadioInput = styled.input`
  display: none;
`

const Radio = ({ name, value, label, defaultChecked, id, onChange, errorMessage, hookForm }) => {
  const [selectedValue, setSelectedValue] = useState('')
  const componentId = uniqid()
  const hasError = !!errorMessage

  const handleChange = (event) => {
    const { value } = event.target

    setSelectedValue(value)
    if (onChange) {
      onChange(value)
    }
  }

  return (
    <Container hasError={hasError}>
      <RadioInput
        { ...hookForm }
        type='radio'
        id={id || componentId}
        name={name}
        value={value}
        checked={defaultChecked}
        onChange={(e) => {
          if (hookForm) hookForm.onChange(e)
          handleChange(e)
        }}
      />

      <label
        htmlFor={id || componentId}
      >
        {label}
      </label>
    </Container>
  )
}

export default Radio
